<div fxLayout="row" fxLayoutAlign="center center">
  <pdf *ngIf="showBenefitsSteps" #pdf [documentTitleText]="documentTitleText" [documentHeaderText]="documentHeaderText">
    <coverage-summary 
      [forPdf]="true"
      [documentTitleText]="documentTitleText"
      [documentHeaderText]="documentHeaderText"
      [enrolledHeader]="enrolledHeader"
      [subscriber]="subscriber"
      [summaryObject]="subscriberSummary"
    ></coverage-summary>
  </pdf>
  <hca-prompt
    [conditionalNextIdx]="legalIndex"
    [conditionalNextMet]="userHasReadLegal"
    [hasBackToDashButton]="hasBackToDashButton"
    (putPostObject)="confirm()"
    fxFlex="90"
    [confirmIndex]="confirmIndex"
    [icon]="icons.faCheck"
    (previous)="updateStep($event)"
    (next)="updateStep($event)"
    [idx]="isDeathOrDivorceSoe ? 1 : step"
    [milestone]="confirmationMilestone"
    [hideBackToDash]="isSOE"
    [hideConfirmButton]="isSOE"
  >
    <div fxLayoutAlign="center center" fxFlex fxFlexFill fxFlexLayout="column" class="container-fluid">
      <coverage-summary
        *ngIf="showBenefitsSteps"
        [step]="step"
        [pageOneStep]="primaryBenefitsIndex"
        [pageTwoStep]="additionalBenefitsIndex"
        [documentTitleText]="documentTitleText"
        [documentHeaderText]="documentHeaderText"
        [enrolledHeader]="enrolledHeader"
        documentFooterText="documentFooterText"
        [subscriber]="subscriber"
        [summaryObject]="subscriberSummary"
      ></coverage-summary>
      <div *ngIf="displayRaceEthnicity && steps[step] === 'Ethnicity'" class="card" fxLayoutAlign="space-between center" fxLayout="column" fxLayout.lt-sm="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <div [fxFlex]="this.subscriber.members?.length > 1 ? 45 : 95" fxLayout="column" class="card">
            <div class="card-body">
              <h3>Subscriber</h3>
              <race-ethnicity (updateMemberObject)="updateSubForEthnicities($event)" [suppressSave]="true" [ethnicities]="ethnicities" [member]="subscriber"></race-ethnicity>
            </div>
          </div>
          <div *ngIf="this.subscriber.members?.length > 1" fxFlex="45" fxLayout="column" class="card">
            <div class="card-body">
              <h3>Spouse or SRDP</h3>
              <race-ethnicity (updateMemberObject)="updateDepForEthnicities($event)" [suppressSave]="true" [ethnicities]="ethnicities" [member]="this.subscriber.members[1]"></race-ethnicity>
            </div>
          </div>
        </div>
      </div>
      <confirm-legal
        *ngIf="!isReadOnly && step === legalIndex"
        [isSebb]="subscriber.isSebb"
        [isMedicalOnly]="subscriber.isMedicalOnlyOrganization"
        [coverageYear]="coverageYear"
        (userHasReadLegal)="userHasReadLegal = true"
      ></confirm-legal>
      <confirm-finish
        [isReadOnly]="isReadOnly"
        [subscriber]="subscriber"
        [isSOE]="isSOE"
        [isHcaAdmin]="isHcaAdmin"
        [soeSubmitted]="soeSubmitted"
        [isDeathOrDivorceSoe]="isDeathOrDivorceSoe"
        *ngIf="step === confirmIndex"
        (navToDashboard)="navToDashboard()"
        (downloadCoveragePDF)="downloadCoveragePDF()"
        (emailSubscriptionUpdated)="putEmailAddress($event)"
        (submitSOERequest)="submitSOERequest()"
        (within60Days)="within60Days = $event"
      ></confirm-finish>
    </div>
  </hca-prompt>
</div>
